<template>
  <!-- 顶部 报表名称 + 筛选条件 -->
  <div class="report-head-search">
    <!-- 报表名称 -->
    <a-row class="report-tit">
      <a-col :span="20" class="title">{{ $t('report.title', {title: $t(reportTitle)}) }}</a-col>
      <a-col :span="4" class="filter">
        <span @click="openFilters"><i class="iconfont iconshaixuan"></i></span>
      </a-col>
    </a-row>
    <!-- 报表筛选 -->
    <div v-show="filterOpen" class="filter-box">
      <!-- 筛选头部 -->
      <a-row class="filter-h" :gutter="30">
        <a-col :span="9">
          <span>{{ $t('formAbout.robotName') }}：</span>
          <a-select v-model="params.robotName">
            <a-select-option v-for="(item, index) in robotOptions" :key="index" :value="item.value"> {{ item.label }} </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="9">
          <span>{{ $t('formAbout.proName') }}：</span>
          <a-select v-model="params.procName">
            <a-select-option v-for="(item, index) in processOptions" :key="index" :value="item.value"> {{ item.label }} </a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <!-- 筛选底部 -->
      <div class="filter-bot-box">
        <a-row class="filter-bot" :gutter="30">
          <a-col :span="9">
            <span>{{ $t('proConfig.time') }}：</span>
            <a-range-picker :value="dateRange" @change="onChange" />
          </a-col>
          <a-col :span="15">
            <!-- 查询模式(今天,昨天....) 键值： 1 今天，2 昨天，3本周，4 上周，5 本月，6 上月 -->
            <a-button @click="setDateType($event, 1)">{{ $t('formAbout.today') }}</a-button>
            <a-button @click="setDateType($event, 2)">{{ $t('formAbout.yesterday') }}</a-button>
            <a-button @click="setDateType($event, 3)">{{ $t('formAbout.thisWeek') }}</a-button>
            <a-button @click="setDateType($event, 4)">{{ $t('formAbout.lastWeek') }}</a-button>
            <a-button @click="setDateType($event, 5)">{{ $t('formAbout.thisMonth') }}</a-button>
            <a-button @click="setDateType($event, 6)">{{ $t('formAbout.lastMonth') }}</a-button>
          </a-col>
        </a-row>
        <!-- 间隔 -->
        <a-row class="filter-bot" :gutter="30">
          <a-col :span="9">
            <span>{{ $t('formAbout.interval') }}：</span>
            <a-select v-model="params.interval">
              <a-select-option value="">{{ $t('formAbout.auto') }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </div>
      <!-- 搜索按钮 -->
      <div class="filter-operation-btn">
        <a-button class="btn-primary" @click="handleFilters">{{ $t('formAbout.searchBtn') }}</a-button>
        <a-button @click="clearFilters">{{ $t('formAbout.clear') }}</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { apiRobot } from '@/api/robot'
import { apiProcess } from '@/api/process'

export default {
  props: {
    reportTitle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      filterOpen: false,
      // 机器人下拉
      robotOptions: [],
      // 流程下拉
      processOptions: [],
      // 数据筛选条件
      params: {
        robotName: '', // 机器人名称
        procName: '', // 流程名
        queryStart: '', // 开始时间
        queryEnd: '', // 结束时间
        queryMode: '', // 查询模式  键值： 1 今天，2 昨天，3本周，4 上周，5 本月，6 上月
        interval: '' // 间隔
      },
      // 日期范围
      dateRange: null
    }
  },
  created () {
    this._fetchSelect()
  },
  watch: {
    // 监听日期范围
    dateRange (newVal, oldVal) {
      if (newVal) {
        this.params.queryMode = ''
        // 将选中的查询模式，恢复为未选中状态
        const ele = document.getElementsByClassName('ant-btn-primary')[0]
        if (ele) ele.className = 'ant-btn ant-btn-default'
      } else {
        this.$set(this.params, 'queryStart', '')
        this.$set(this.params, 'queryEnd', '')
      }
    },
    // 监听查询模式
    'params.queryMode' (newVal, oldVal) {
      if (newVal) {
        this.$set(this.params, 'queryStart', '')
        this.$set(this.params, 'queryEnd', '')
        this.dateRange = null
      }
    }
  },
  methods: {
    // 控制筛选条件的显示/隐藏
    openFilters () {
      this.filterOpen = !this.filterOpen
    },
    /**
     * 获取机器人/流程 下拉数据
     */
    _fetchSelect () {
      apiRobot.list().then(data => {
        this.robotOptions = [{ value: '', label: `-- ${this.$t('formAbout.all')} --` }]
        if (!data.total) return
        const list = data.items.map(item => {
          return {
            value: item.agentNo,
            label: item.agentAlias || item.agentNo
          }
        })
        this.robotOptions = [...this.robotOptions, ...list]
      })
      apiProcess.list().then(data => {
        this.processOptions = [{ value: '', label: `-- ${this.$t('formAbout.all')} --` }]
        if (!data.total) return
        const list = data.items.map(item => {
          return {
            value: item.procCode,
            label: item.procName || item.procCode
          }
        })
        this.processOptions = [...this.processOptions, ...list]
      })
    },
    onChange (date, dateString) {
      // console.log(date, dateString)
      // 将可受控的dateRange赋值，方便后期清空
      this.dateRange = date
      // 设置时间日期的筛选值
      if (date) {
        this.params.queryStart = dateString[0]
        this.params.queryEnd = dateString[1]
      }
    },
    // 设置筛选查询模式
    setDateType (e, queryMode = '') {
      // 设置查询模式
      this.params.queryMode = queryMode
      const allBtn = document.getElementsByClassName('ant-btn-primary')
      // console.log(allBtn[0])
      // 将之前选中的样式清除
      if (allBtn[0]) {
        allBtn[0].className = 'ant-btn ant-btn-default'
      }
      // 将当前点击的按钮设为选中状态
      e.target.className = 'ant-btn ant-btn-primary'
    },
    // 根据筛选条件获取对应的数据
    handleFilters () {
      this.$emit('search', this.params)
    },
    // 清空筛选条件
    clearFilters () {
      // 清空填写的筛选条件，并重新获取所有的数据
      const _this = this
      // 将筛选条件置空
      Object.keys(this.params).forEach(key => {
        _this.$set(_this.params, key, '')
      })
      // 将日期选择器置空
      this.dateRange = null
      // 将选中的查询模式，恢复为未选中状态
      document.getElementsByClassName('ant-btn-primary')[0].className = 'ant-btn ant-btn-default'
    }
  }
}
</script>

<style lang="less" scoped>
  .btn-primary {
    color: #fff;
    background-color: #1890ff;
    border-color: #1890ff;
    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  }
  .report-head-search {
    margin-bottom: 24px;
    .report-tit {
      height: 28px;
    }
    .title {
      font-size: 20px;
      font-weight: bold;
      color: #666;
    }
    .filter {
      justify-content: flex-end;
      display: flex;
      >span {
        cursor: pointer;
        display: flex;
        width: 28px;
        height: 28px;
        background-color: #4977FC;
        border-radius: 4px;
        align-items: center;
        justify-content: center;
        .iconfont {
          color: #fff;
        }
      }
    }
  }
  .filter-box {
    margin-top: 24px;
    background-color: #fff;
    padding-bottom: 24px;
    border: 1px solid #F7F7F7;
    .filter-h {
      padding: 24px;
      padding-right: 0px;
      border-bottom: 1px solid #eee;
    }
    .filter-bot-box {
      padding: 24px;
      padding-right: 0px;
    }
    .filter-bot {
      padding-top: 12px;
      &:first-of-type {
        padding-top: 0;
      }
      [class^=ant-col-] {
        > button {
          margin-right: 8px;
        }
      }
    }
    [class^=filter-] {
      [class^=ant-col-] {
        >span {
          display: inline-block;
          width: 100px;
        }
        .ant-select,
        .ant-calendar-picker {
          width: calc(100% - 100px)!important;
        }
      }
    }
    .filter-operation-btn {
      padding-left: 124px;
      > button {
        margin-right: 8px;
      }
    }
  }
  .chart-box {
    margin-top: 24px;
    [class^=ant-col-] {
      > div {
        background-color: #fff;
        padding: 24px;
      }
    }
  }
</style>
